import { render, staticRenderFns } from "./PhoneInputInternal.vue?vue&type=template&id=2b088f6a&"
import script from "./PhoneInputInternal.vue?vue&type=script&lang=js&"
export * from "./PhoneInputInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports